import React from 'react';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
export const FlatButton = (props) => {
    const { children, size = 'medium', fullWidth, loading = false, disabled = false, onClick } = props;
    return (React.createElement(Button, { variant: "contained", size: size, fullWidth: fullWidth, disabled: loading || disabled, onClick: onClick }, loading ? React.createElement(CircularProgress, { size: 30 }) : children));
};
